export const RELEASE_ID_PATTERN = /^[a-f0-9]{64}$/;
export const COMPILED_RELEASE_ID = process.env.REACT_APP_RELEASE_ID || '';

export function releaseProvenanceUrl(
  backendBase = process.env.REACT_APP_BACKEND_URL || '',
) {
  return `${backendBase.replace(/\/+$/, '')}/api/release-provenance`;
}

export async function verifyReleaseProvenance({
  expectedReleaseId = COMPILED_RELEASE_ID,
  fetchImpl = fetch,
  backendBase,
} = {}) {
  if (!RELEASE_ID_PATTERN.test(expectedReleaseId)) {
    throw new Error('release_id_missing_or_invalid');
  }

  const response = await fetchImpl(releaseProvenanceUrl(backendBase), {
    method: 'GET',
    cache: 'no-store',
    credentials: 'omit',
    redirect: 'error',
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) {
    throw new Error('release_provenance_unavailable');
  }

  const payload = await response.json();
  if (
    payload?.schema_version !== 1
    || payload?.release_id !== expectedReleaseId
    || payload?.backend_release_id !== expectedReleaseId
    || payload?.frontend_release_id !== expectedReleaseId
  ) {
    throw new Error('release_provenance_mismatch');
  }
  return expectedReleaseId;
}
